export const CALLOUT_COLORS = [
  { value: 'gray', label: 'グレー' },
  { value: 'brown', label: 'ブラウン' },
  { value: 'orange', label: 'オレンジ' },
  { value: 'yellow', label: 'イエロー' },
  { value: 'green', label: 'グリーン' },
  { value: 'blue', label: 'ブルー' },
  { value: 'purple', label: 'パープル' },
  { value: 'pink', label: 'ピンク' },
  { value: 'red', label: 'レッド' },
] as const

export type CalloutColor = (typeof CALLOUT_COLORS)[number]['value']

export const CALLOUT_ICONS = ['💡', '📌', 'ℹ️', '✅', '⚠️', '❗', '❓', '🔥', '📝', '⭐', '🚫', '💬'] as const

export const DEFAULT_CALLOUT_ICON = '💡'
export const DEFAULT_CALLOUT_COLOR: CalloutColor = 'gray'

export const toCalloutColor = (value: unknown): CalloutColor =>
  CALLOUT_COLORS.find((c) => c.value === value)?.value ?? DEFAULT_CALLOUT_COLOR
